import { waitForElement } from '../../../js/utils'

class Banner {
  constructor() {
    waitForElement('.en__p2p__image img').then((banner) => {
      banner = banner.parentElement
      setTimeout(() => this.setBannerHeight(banner), 300)
      window.addEventListener('resize', () => this.setBannerHeight(banner))
    })
  }

  setBannerHeight(banner) {
    if (!banner) {
      return
    }
    const height = banner.offsetHeight
    const enPage = document.querySelector('.en__p2p__page')
    enPage && enPage.style.setProperty('--banner-height', `${height}px`)
  }
}

export default Banner
